import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';

function CheckToken(resp) {

    // let timeToLogout = (new Date((localStorage.getItem('login_token_expire_time')))).getTime() - (new Date()).getTime();
    // alert(timeToLogout)
    // setTimeout(() => {
    //     localStorage.clear();
    //     // window.location.reload();
    //     resp(false);
    // }, timeToLogout);
}

// to create event

export function CreateEvents(store, eventObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
   
    return PnkAjax(store).Post('events/json/').ExtraData(eventObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
   
   
}

// to get the event list on admin panel

export function GetEventsList(store, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    CheckToken(function (returnValue) {
        // alert(returnValue)
    });
    return PnkAjax(store).Get('events/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// to get the detail of any event

export function EventDetail(store, event_id, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('event/json/' + event_id).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

//  eventDetail with userId

export function EventDetailByUser(store, event_id, user_id, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('event/json/' + event_id  +'/' + user_id).AttachLoader(loader).WetherPinakaResponse(false).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// to get the upcoming events on home page

export function UpcomingEvents(store, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('upcomingevents/json/1/3').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// to get the all upcoming events 

export function AllUpcomingEvents(store, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('upcomingevents/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// all events for sitemap

export function SitemapEventsList(store, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('sitemapevents/json').AttachLoader(loader).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// to update the event details

export function UpdateEventDetails(store, event_id, editObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Put('event/json/' + event_id).ExtraData(editObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// to joint the event

export function JoinEvent(store, eventObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Post('eventjoining/json').ExtraData(eventObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// to get user booked events

export function MyEvents(store, user_id, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('joineventlistbyuser/json/' + user_id).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// to rate the events

export function RateEvent(store, eventObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Put('eventratings/json').ExtraData(eventObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// filter events

export function FilterEvent(store, eventObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Post('filterevent/json/all').ExtraData(eventObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// cancel booking

export function CancelBooking(store, eventObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Put('cancelbooking/json').ExtraData(eventObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}
